// Replays a phone-remote D-pad press as the same synthetic keydown a real TV
// remote emits. Used by RemoteNavBridge (postMessage iframe path) and by the
// in-app TvCastReceiver (MQTT path on TVs that run the app directly).

export const NAV_KEY_SPECS = {
  up: ['ArrowUp', 38],
  down: ['ArrowDown', 40],
  left: ['ArrowLeft', 37],
  right: ['ArrowRight', 39],
  select: ['Enter', 13],
  back: ['Escape', 27],
};

const FOCUSABLE =
  'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [data-focusable]';

const firstVisibleFocusable = () =>
  Array.from(document.querySelectorAll(FOCUSABLE)).find((el) => {
    if (el.getAttribute('aria-hidden') === 'true') return false;
    return el.getClientRects().length > 0;
  });

const fireKey = (key, keyCode) => {
  const target = document.activeElement || document.body;
  let event;
  try {
    event = new KeyboardEvent('keydown', {
      key,
      code: key,
      keyCode,
      which: keyCode,
      bubbles: true,
      cancelable: true,
    });
  } catch (err) {
    return false;
  }
  try {
    Object.defineProperty(event, 'keyCode', { get: () => keyCode });
    Object.defineProperty(event, 'which', { get: () => keyCode });
  } catch (err) {
    /* read-only in some engines; key fallback still works */
  }
  target.dispatchEvent(event);
  return true;
};

// value: up|down|left|right|select|back|home. `navigate` handles Home.
export const dispatchNavKey = (value, navigate) => {
  const v = String(value || '').toLowerCase();
  if (v === 'home') {
    if (typeof navigate === 'function') navigate('/');
    return true;
  }
  const spec = NAV_KEY_SPECS[v];
  if (!spec) return false;

  if (v === 'select') {
    const active = document.activeElement;
    if (!active || active === document.body) {
      const first = firstVisibleFocusable();
      if (first) {
        try { first.focus({ preventScroll: true }); } catch (err) { first.focus(); }
      }
    }
  }

  return fireKey(spec[0], spec[1]);
};
